"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTransitionGroup = require("react-transition-group");

var _lodash = require("lodash");

var _Button = _interopRequireDefault(require("../Button"));

var _Remove = _interopRequireDefault(require("../../icons/Remove"));

var _Info = _interopRequireDefault(require("../../icons/Info"));

var _ErrorCircle = _interopRequireDefault(require("../../icons/ErrorCircle"));

var _SuccessCircle = _interopRequireDefault(require("../../icons/SuccessCircle"));

var _AlertWarning = _interopRequireDefault(require("../../icons/AlertWarning"));

require("./toast.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
  Slightly hacky: list out all possible classes for purgeCSS
  toast-info-top-border
  toast-success-top-border
  toast-alert-top-border
  toast-error-top-border
 */


function ToastIcon(_ref) {
  var type = _ref.type;
  var iconProps = {
    size: 28
  };

  if (type === 'error') {
    return _react.default.createElement(_ErrorCircle.default, iconProps);
  } else if (type === 'success') {
    return _react.default.createElement(_SuccessCircle.default, iconProps);
  } else if (type === 'alert') {
    return _react.default.createElement(_AlertWarning.default, iconProps);
  }

  return _react.default.createElement(_Info.default, iconProps);
}

function Toast(props) {
  var type = props.type,
      isOpen = props.isOpen,
      onClose = props.onClose,
      header = props.header,
      body = props.body,
      actions = props.actions,
      className = props.className,
      containerClassName = props.containerClassName,
      onExited = props.onExited;
  var hasActions = !(0, _lodash.isEmpty)(actions);
  var numWords = (0, _lodash.words)(body).length;
  var timeoutInMs = numWords * 3 / 10.0 * 1000;
  (0, _react.useEffect)(function () {
    if (isOpen && !hasActions) {
      var tid = setTimeout(function () {
        return onClose();
      }, timeoutInMs);
      return function () {
        return clearTimeout(tid);
      };
    }
  }, [isOpen, onClose, hasActions, timeoutInMs]);
  return _react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: isOpen,
    timeout: 1000,
    appear: true,
    classNames: "toast",
    unmountOnExit: true,
    onExited: onExited
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)('m-2 w-auto rounded flex flex-col toast-bg lg:w-360px pointer-events-auto', containerClassName),
    "data-testid": "toast-container"
  }, _react.default.createElement("div", {
    className: "rounded-t w-full toast-".concat(type, "-top-border"),
    "data-testid": "top-border"
  }), _react.default.createElement("div", {
    className: (0, _classnames.default)('flex justify-between md:justify-start lg:justify-between items-start p-4', className),
    "data-testid": "toast-display"
  }, _react.default.createElement("div", {
    className: "pr-4",
    "data-testid": "toast-icon-".concat(type)
  }, _react.default.createElement(ToastIcon, {
    type: type
  })), _react.default.createElement("div", {
    className: "flex flex-col justify-between flex-grow"
  }, _react.default.createElement("div", {
    className: "flex justify-between items-center"
  }, _react.default.createElement("div", {
    className: "text-white font-extrabold text-lg"
  }, header)), _react.default.createElement("div", {
    className: "text-white text-base py-2"
  }, body), hasActions && _react.default.createElement("div", {
    className: "flex flex-shrink-0 w-full pt-2"
  }, (0, _lodash.map)(actions, function (action, idx) {
    var className = action.className,
        variant = action.variant,
        onButtonClick = action.onClick,
        rest = _objectWithoutProperties(action, ["className", "variant", "onClick"]);

    return _react.default.createElement("div", {
      key: action.label,
      className: "w-full md:w-auto ".concat(idx === 0 ? '' : 'ml-2')
    }, _react.default.createElement(_Button.default, _extends({}, rest, {
      color: "inverted",
      onClick: function onClick() {
        if (onButtonClick) onButtonClick();
        onClose();
      },
      variant: variant,
      className: (0, _classnames.default)(className, {
        'toast-btn-text-color': variant === undefined || variant === 'solid',
        'w-full': actions.length === 1
      })
    })));
  }))), _react.default.createElement("div", {
    className: "-mt-1"
  }, _react.default.createElement(_Remove.default, {
    size: 28,
    onClick: onClose,
    className: "cursor-pointer text-white"
  })))));
}

Toast.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onExited: _propTypes.default.func,
  type: _propTypes.default.oneOf(['info', 'success', 'alert', 'error']),
  header: _propTypes.default.string.isRequired,
  body: _propTypes.default.string.isRequired,
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func,
    className: _propTypes.default.string,
    variant: _Button.default.type.propTypes.variant
  })),
  className: _propTypes.default.string,
  containerClassName: _propTypes.default.string
};
Toast.defaultProps = {
  type: 'info',
  actions: [],
  className: '',
  containerClassName: '',
  onExited: function onExited() {}
};

var _default = _react.default.memo(Toast);

exports.default = _default;